export class PartsFilterModel {
  number: string;
  productLine: string;
  subProductLine: string;
  make: string;
  name: string;
  partType: string;
  description: string;
  keyword: string;
  skuName: string;
  active: string;
  searchString: string;
}
